import { useState } from "react";
import cn from "classnames";
import styles from "./CarrierIcon.module.scss";

const monogramColor = (seed: string): string => {
  let hash = 0;

  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }

  return `hsl(${hash % 360}, 40%, 38%)`;
};

const monogramText = (label?: string, code?: string): string => {
  const words = String(label || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }

  if (words.length === 1 && words[0].length >= 2) {
    return words[0].slice(0, 2).toUpperCase();
  }

  return String(code || "?")
    .slice(0, 2)
    .toUpperCase();
};

type CarrierIconProps = {
  src: string;
  label: string;
  code: string;
  className?: string;
  /** Square icon side, in px. Matches the 20x20 select rows by default. */
  size?: number;
};

export const CarrierIcon: RFC<CarrierIconProps> = ({ src, label, code, className, size = 20 }) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <span
        className={cn(styles.monogram, className)}
        style={{ width: size, height: size, backgroundColor: monogramColor((code || label || "").toUpperCase()) }}
        aria-hidden
      >
        {monogramText(label, code)}
      </span>
    );
  }

  return (
    <img src={src} alt={label} width={size} height={size} className={className} onError={() => setHasError(true)} />
  );
};
